import type { HelpTopic } from "./types";

/**
 * Top-level topics shown as tiles on /help — modeled on airbnb.co.uk/help.
 * Title and description strings live in i18n (`helpCentre.topics.<slug>.*`)
 * so they translate naturally; the slug itself stays locale-neutral and
 * forms the URL `/help/topic/<slug>`.
 */
export const HELP_TOPICS: HelpTopic[] = [
  {
    slug: "getting-started",
    titleKey: "helpCentre.topics.getting-started.title",
    descriptionKey: "helpCentre.topics.getting-started.description",
    icon: "Sparkles",
  },
  {
    slug: "booking-a-car",
    titleKey: "helpCentre.topics.booking-a-car.title",
    descriptionKey: "helpCentre.topics.booking-a-car.description",
    icon: "Car",
  },
  {
    slug: "hosting",
    titleKey: "helpCentre.topics.hosting.title",
    descriptionKey: "helpCentre.topics.hosting.description",
    icon: "KeyRound",
  },
  {
    slug: "payments-and-refunds",
    titleKey: "helpCentre.topics.payments-and-refunds.title",
    descriptionKey: "helpCentre.topics.payments-and-refunds.description",
    icon: "Wallet",
  },
  {
    slug: "insurance-and-protection",
    titleKey: "helpCentre.topics.insurance-and-protection.title",
    descriptionKey: "helpCentre.topics.insurance-and-protection.description",
    icon: "ShieldCheck",
  },
  {
    slug: "account",
    titleKey: "helpCentre.topics.account.title",
    descriptionKey: "helpCentre.topics.account.description",
    icon: "User",
  },
  {
    slug: "trust-and-safety",
    titleKey: "helpCentre.topics.trust-and-safety.title",
    descriptionKey: "helpCentre.topics.trust-and-safety.description",
    icon: "Lock",
  },
  {
    slug: "cancellations",
    titleKey: "helpCentre.topics.cancellations.title",
    descriptionKey: "helpCentre.topics.cancellations.description",
    icon: "CalendarX",
  },
  {
    slug: "moving-from-the-old-platform",
    titleKey: "helpCentre.topics.moving-from-the-old-platform.title",
    descriptionKey: "helpCentre.topics.moving-from-the-old-platform.description",
    icon: "ArrowLeftRight",
  },
];
